import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from 'src/app/application/account/account.service';
import { ShareService } from '../services/share-service';
import { ClientDocs } from 'src/app/models/client-docs';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-client-docs-popup',
  templateUrl: './client-docs-popup.component.html',
  styleUrls: ['./client-docs-popup.component.scss']
})
export class ClientDocsPopupComponent {

  @ViewChild('content') docView !: ElementRef
  @Output() dataAdded: EventEmitter<void> = new EventEmitter<void>();

  constructor(private modalService: NgbModal, private apiService:AccountService,private shareService: ShareService) { }

  ngOnInit(): void {
    this.loadDocTypes();
  }

  errormessage = '';
  errorclass = '';
  saveresponse: any;
  docData: ClientDocs;
  editdata: any;
  docTypes:any;

  docForm = new FormGroup({
    id:new FormControl(),
    client_id: new FormControl(),
    client_file: new FormControl('', Validators.compose([Validators.required])),
    file_comment: new FormControl(),
    doc_type: new FormControl('', Validators.compose([Validators.required]))
  });

  saveDocument(){
    if(this.docForm.valid){
      // console.log("employment data "+JSON.stringify(this.docform.value));
      this.docData = new ClientDocs(this.docForm.value);
      this.docData.client_id = this.shareService.getLinkedClientId();

      // console.log("relation data "+JSON.stringify(this.relationData));

      this.apiService.saveClientDocument(this.docData).then(res =>{
        // console.log("response "+JSON.stringify(res));
        if(res["status"] == 1){
          this.closeModalForm();
          // this.
          this.dataAdded.emit();
        }
      })
    }
    else{
      this.errormessage = "Please enter valid data";
      this.errorclass = "errormessage";
    }
  }

  loadEditData(id: any){
    this.openModalForm();
    this.apiService.getClientDocument(id).then(result => {
      console.log("employment details "+JSON.stringify(result));

      var document = result["data"];

      this.docForm.patchValue(
        { id:document.id,
          file_comment: document.file_description,
          client_file: document.doc_file,
          doc_type: document.doc_type
      });
    });
  }

  deleteDocument(id:number){
    this.apiService.deleteClientDocument(id).then(result=>{
      if(result["status"] == 1){
        // this.closeModalForm();
        this.dataAdded.emit();
      }
    })
  }




  openModalForm(){
    this.clearForm();
    this.modalService.open(this.docView,{ ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModalForm(){
    this.clearForm();
    this.modalService.dismissAll();
  }

  clearForm(){
  //   this.docForm.patchValue({id:null,relation_name:"",relation_start_date:"",relation_end_date:"",relation_phone:"",relation_type:"",
  // relation_address:""});
  }

  loadDocTypes(){
    this.apiService.getDocTypesDll().then(res => {
      this.docTypes =  res;
    });
    // console.log("rel types "+this.relationTypes);
  }

}

